import type {SalesRepository} from '../repository/SalesRepository';
import type {Sale, SalesQueryParams} from '../models/sale.model';

export class GetSalesWithFiltersUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (params: SalesQueryParams): Promise<{ items: Sale[]; pagination?: any }> {
    return this.salesRepository.getSalesWithFilters(params);
  }
}
